import React from 'react'

const WelcomeTitle = ({ label }) => {
    return <h1 className="font-bold text-2xl pb-6">{label}</h1>
}

export default WelcomeTitle
